import { useState } from 'react';
import useDeviceInfo from '../../services/helpers/custom_hook/useDeviceInfo';
import openInNewTabAttr from '../../services/helpers/openInNewTabAttr';
import DesktopMenu from './Menu/DesktopMenu';
import MobileMenu from './Menu/MobileMenu';
import './header.sass';

const Header = ({ header }) => {
  const { isMobile } = useDeviceInfo();
  const {
    logo,
    mainNavOptions: mainNavOptions = [],
    mainNavMenu: mainNavMenu = [],
    mainNavMenuMobile: mainNavMenuMobile = [],
    cta,
  } = header;
  const [isHovered, setIsHovered] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const showDesktopMenu = !isMobile && mainNavMenu.length > 0;

  return (
    <header className='header-wrapper'>
      <div className='header-content-wrapper'>
        <div className='header-content'>
          <div className='header-sector-wrapper'>
            <div className='header-left-sector'>
              {isMobile && (
                <MobileMenu
                  mainLinks={mainNavOptions}
                  menuItems={mainNavMenuMobile}
                />
              )}
              <a href={logo.link}>
                <img className='header-logo' src={logo.url} alt='Logo' />
              </a>
              <div className='header-options-container'>
                {mainNavOptions.map((mainNavOption, i) => {
                  if (mainNavOption?.subLinks?.length > 0) {
                    return (
                      <div key={i}>
                        <a
                          className='header-option'
                          href={mainNavOption.link}
                          onMouseEnter={() => {
                            setSelectedOption(i);
                            setIsHovered(true);
                          }}
                          {...openInNewTabAttr(mainNavOption.newTab)}
                        >
                          <p className='header-option-title'>
                            {mainNavOption.title}
                          </p>
                          {/*<Icon
                            iconKey={
                              selectedOption === i
                                ? IconKey.CHEVRON_UP
                                : IconKey.CHEVRON_DOWN
                            }
                            size={IconSize.XSMALL}
                          />*/}
                        </a>
                        {(selectedOption !== null || isHovered) && (
                          <div
                            className='header-dropdown-container'
                            onMouseLeave={() => {
                              setSelectedOption(null);
                              setIsHovered(false);
                            }}
                          >
                            <div className='header-dropdown-menu'>
                              {mainNavOptions[selectedOption].subLinks.map(
                                ({ id, title, links }) => {
                                  return (
                                    <div
                                      className='header-dropdown-links'
                                      key={id}
                                    >
                                      <h2>{title}</h2>
                                      {links.locations.map((location) => (
                                        <a
                                          key={location.title}
                                          href={location.link}
                                        >
                                          {location.title}
                                        </a>
                                      ))}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  } else {
                    return (
                      <a
                        className='header-option'
                        key={i}
                        href={mainNavOption.link}
                        onMouseEnter={() => {
                          setSelectedOption(null);
                          setIsHovered(false);
                        }}
                        {...openInNewTabAttr(mainNavOption.newTab)}
                      >
                        {mainNavOption.title}
                      </a>
                    );
                  }
                })}
              </div>
            </div>
            <div className='header-right-sector'>
              {showDesktopMenu && <DesktopMenu menuItems={mainNavMenu} />}
              {cta && (
                <a
                  className='header-cta'
                  href={cta.link}
                  {...openInNewTabAttr(cta.newTab)}
                >
                  {cta.title}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
